export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Klávesnice"},
    mouse: {name: "Myš"},
    webcam: {name: "Webová kamera"},
    headset: {name: "Sluchátka"},
    dockingStation: {name: "Dokovací stanice"},
}